<template>
  <div class="sm-facet_category">
    <ul>
      <li>
        <button v-if="selected_category > 0" @click.stop="onSelectCategory(0)" class="sm-facet-category">
          <span class="sm-facet-category__text">Все категории</span>
        </button>
      </li>

      <li v-if="selected_category > 0">
        <button disabled="disabled" class="sm-facet-category sm-facet-category_active">
          <span class="sm-facet-category__text">{{ this.getCategoryName() }}</span>
          <span class="sm-facet-category__amount">{{ this.getCategoryValue() }}</span>
        </button>
      </li>
      <li v-else v-for="item in categories" :key="item.id">
        <button v-show="item.value > 0"
            class="sm-facet-category"
            @click.stop="onSelectCategory(item.id)"
        >
          <span class="sm-facet-category__text">{{ item.name }}</span>
          <span class="sm-facet-category__amount">{{ item.value }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
name: "facet-categories",
  computed: {
    ...mapGetters("search", ["selected_category", "categoryFacets"]),
    categories: function () {
      return this.categoryFacets;
    },
    selectedCategoryInfo: function () {
      let selected = this.selected_category;
      return this.categories.filter(function (item) {
        return item.id === selected;
      })
    }
  },
  methods: {
    ...mapActions("search", [ "selectCategory", "addFilter", "doSearch", "resetFilters"]),
    onSelectCategory: function (category_id) {
      this.selectCategory(category_id);

      //if(category_id === 0) {
        this.resetFilters();
      //}
      this.addFilter({category: category_id});

      this.doSearch().then(() => {}).catch(err => { console.log(err.response.statusText) });
    },
    getCategoryName() {
      const info = this.selectedCategoryInfo;
      return (typeof info[0] !== 'undefined') ? info[0].name : '';
    },
    getCategoryValue() {
      const info = this.selectedCategoryInfo;
      return (typeof info[0] !== 'undefined') ? info[0].value : '';
    }
  }
}
</script>